import { i18n } from "@lingui/core"

export function formatQuantity(value: number | string) {
  const numberValue = Number(value)

  if (Number.isNaN(numberValue)) return "0"

  return numberValue.toLocaleString(i18n.locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  })
}
